import {
  Component,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
  Inject
} from "@angular/core";
import { EcoMasterData, EcoMasterRequest } from "@tmhcc-ng-lib/data-service";
import {
  Router,
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationStart
} from "@angular/router";
import { LoaderService } from "@tmhcc-ng-lib/framwork/loader";
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { OktaAuth } from '@okta/okta-auth-js';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';

@Component({
    selector: "ec-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
  title = "policy-admin";
  isAuthenticated: boolean = false;
  isLoading: boolean = false;

  constructor(
    private masterData: EcoMasterData,
    public router: Router,
    public loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    protected configService: AppConfigService,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
  ) {
    this.loaderService.isLoading.subscribe(loader => {
      //Remove Error
      setTimeout(() => {
        this.isLoading = loader;
      }, 200);
      // this.cdr.detectChanges();
    });
    this.loaderService.show();
  }

  async ngOnInit() {
    // Get the authentication state for immediate use
    this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    if (this.isAuthenticated) {
      this.removeClass("topheader", "hide");
      await this.setWelcomeUser();
    } else {
      this.addClass("topheader", "hide");
    }
  }

  ngAfterViewInit() {
    this.loaderService.hide();
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // this.loaderService.show();
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel
      ) {
        setTimeout(() => {
          // this.loaderService.hide();
        }, 50);
      }
    });
  }

  dashboardLink() {
    const elem = document.querySelector("#dashboardHeader");
    if (elem) {
      elem.addEventListener(
        "click",
        this.navigateToDashboard.bind(this),
        false
      );
    }
  }

  navigateToDashboard() {      
    if (this.router.url === "/wuw-dashboard")
      this.router.navigate(["/dashboard"]);
    else 
      this.router.navigate(["/wuw-dashboard"]);
  }

  async setWelcomeUser() {  
    const userClaims = await this.oktaAuth.getUser();     
    // user name is exposed directly as property
    var element = document.getElementById("headerUserName");
    //debugger;
    element.innerHTML = userClaims.name;

    this.dashboardLink();

    // this.oktaAuth.getUser().then(user => {
    //   var element = document.getElementById('headerUserName');
    //   debugger;
    //   element.innerHTML = user.given_name;
    // })
  }
  addClass(elementId, className) {
    if (document.getElementById(elementId)) {
      var element = document.getElementById(elementId);
      if (element.classList) {
        element.classList.add(className);
      }
    }
  }
  removeClass(elementId, className) {
    if (document.getElementById(elementId)) {
      var element = document.getElementById(elementId);
      if (element.classList) {
        element.classList.remove(className);
      }
    }
  }

  login() {
    this.router.navigate(['dashboard']);
  }
  async logout() {
    sessionStorage.removeItem('UserId');
    sessionStorage.removeItem('okta-app-url');
    sessionStorage.removeItem('navigator');
    sessionStorage.removeItem('claimInfo');
    localStorage.removeItem('okta-cache-storage');
    localStorage.removeItem('okta-token-storage');

    this.addClass("topheader", "hide");
    sessionStorage.clear();
    localStorage.clear();
    const url = `${this.configService.config.baseHref}/login`;
    // await this.oktaAuth.signOut({postLogoutRedirectUri: url});
    await this.oktaAuth.signOut();
  }
}
